export const issuerStateSelector = (state) => {
    return state.policyData && state.policyData.billGroupData && state.policyData.billGroupData.policy.contractState;
};